import React from "react";

import { Icon } from "@iconify/react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "js/components/ui/card";

interface AccentConfig {
  iconBg: string;
  iconText: string;
  iconRing?: string;
}

interface StatsCardProps {
  value: number;
  text: string;
  icon: string;
  accent: AccentConfig;
  helperText?: string;
  valueClassName?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({
  value,
  text,
  icon,
  accent,
  helperText,
  valueClassName,
}) => {
  return (
    <Card className="group h-full overflow-hidden transform border border-slate-200/70 bg-white px-0 py-0 shadow-none transition-all duration-200 hover:-translate-y-px hover:shadow-[0_6px_12px_-10px_rgba(15,23,42,0.25)]">
      <CardHeader className="flex w-full items-center justify-between px-4 py-3 sm:flex-col sm:items-start sm:gap-2 sm:pb-0 sm:pt-3">
        <div className="flex min-w-0 items-center gap-3 sm:w-full">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full ${accent.iconBg} ${accent.iconText} ${accent.iconRing ?? ""}`}
          >
            <Icon fontSize={18} icon={icon} />
          </span>
          <div className="space-y-0.5">
            <CardTitle className="text-sm font-semibold text-slate-800">
              {text}
            </CardTitle>
            {helperText && (
              <CardDescription className="text-xs text-slate-500">
                {helperText}
              </CardDescription>
            )}
          </div>
        </div>
        <span className="ml-4 shrink-0 text-base font-semibold text-slate-900 sm:hidden">
          {value.toLocaleString("es-MX")}
        </span>
      </CardHeader>
      <CardContent className="hidden px-4 pb-3 pt-2 sm:block">
        <div
          className={`text-2xl font-semibold text-slate-900 ${valueClassName ?? ""}`}
        >
          {value.toLocaleString("es-MX")}
        </div>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
